import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询合同乙方列表
export function queryContractPartyb(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartyb/queryContractPartyb',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加合同乙方
export function saveContractPartyb(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartyb/saveContractPartyb',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改合同乙方
export function updateContractPartyb(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartyb/updateContractPartyb',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除合同乙方
export function deleteContractPartyb(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartyb/deleteContractPartyb',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}